<div class="zwi-series-card">
  <div>
    <div class="zwi-series-info-card__title">{{ seriesInfo.name }}</div>
    <div>{{ seriesInfo.sermonNum }} sermons</div>
  </div>
</div>
